import CheckIcon from "@mui/icons-material/Check";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { motion } from "framer-motion";
import {
  professionalServices,
  services,
} from "../../../../utils/siteContent";
import { getIcon } from "../../../../utils/iconMap";
import { revealProps } from "../../../../utils/motion";
import Reveal from "../../../commons/reveal/reveal";
import SectionHeading from "../../../commons/sectionHeading/sectionHeading";
import { StyledLayout } from "../../../styled/layout";
import { StyledServices } from "../../../styled/services";

const MotionCard = motion(StyledServices.Card);
const MotionPro = motion(StyledServices.Pro);

const Services = () => (
  <StyledServices.Root id="que-hacemos">
    <StyledLayout.Container>
      <Reveal>
        <SectionHeading
          tag="Qué hacemos"
          title={
            <>
              Una plataforma para cada actor de la{" "}
              <StyledLayout.GradientText>salud laboral</StyledLayout.GradientText>
            </>
          }
          lead="Ponemos la tecnología al servicio de las organizaciones con productos de última generación, diseñados para prestadores, empresas y aseguradoras."
        />
      </Reveal>

      <StyledServices.Grid>
        {services.map((s, i) => {
          const Icon = getIcon(s.icon);
          return (
            <MotionCard key={s.id} {...revealProps(i * 0.08)}>
              <StyledServices.Glow className="glow" aria-hidden="true" />
              <StyledServices.Icon>
                <Icon />
              </StyledServices.Icon>
              <StyledServices.Title>{s.title}</StyledServices.Title>
              <StyledServices.Summary>{s.summary}</StyledServices.Summary>
              <StyledServices.List>
                {s.features.map((f) => (
                  <li key={f}>
                    <CheckIcon /> {f}
                  </li>
                ))}
              </StyledServices.List>
              <StyledServices.Link href="#contacto">
                Quiero saber más <NorthEastIcon />
              </StyledServices.Link>
            </MotionCard>
          );
        })}
      </StyledServices.Grid>

      <MotionPro {...revealProps()}>
        <StyledServices.ProHead>
          <h3>Servicios profesionales que acompañan cada etapa</h3>
          <p>Del primer día a la operación diaria, con un equipo experto detrás.</p>
        </StyledServices.ProHead>
        <StyledServices.ProList>
          {professionalServices.map((p) => (
            <li key={p}>
              <CheckIcon /> {p}
            </li>
          ))}
        </StyledServices.ProList>
      </MotionPro>
    </StyledLayout.Container>
  </StyledServices.Root>
);

export default Services;
